/* eslint-disable camelcase */
import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';
import ProductInfoCard from 'components/product-info-card';
import BuyBox from 'components/buy-box';
import BrandsList from 'components/brands-list';

export default class ProductDetailsPanel extends PureComponent {
    static propTypes = {
        product: PropTypes.object.isRequired,
    };

    render() {
        const { product } = this.props;
        return (
            <section className="product-details-panel grid grid__base">
                <div className="grid--container">
                    <ProductInfoCard { ...product }/>
                </div>
                <BuyBox product={ product } />
                <div className="grid--container">
                    <BrandsList brands={product.brands}/>
                </div>
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/product-details-panel/index.js